import type { Identifier } from '@atlaskit/media-client/identifier';

export const getOccurrenceKey = (identifier?: Identifier): string | undefined => {
	if (identifier && 'occurrenceKey' in identifier && typeof identifier.occurrenceKey === 'string') {
		return identifier.occurrenceKey;
	}
};

// A missing key on either side still matches, so identifiers without occurrence keys fall back to
// matching on file id alone.
export const occurrenceKeysMatch = (first?: string, second?: string): boolean =>
	!first || !second || first === second;
